import React from "react";
import { Line } from "react-chartjs-2";

export default function PortfolioIntroLineChartCard({
  title,
  value,
  subtexts = [],
  chartData,
  chartOptions,
  chartHeight = "140px",
  emptyMessage = "차트 데이터가 없습니다.",
  valueClassName = "portfolio-intro-card-value",
}) {
  return (
    <div className="h-100 portfolio-intro-card">
      <div className="portfolio-intro-card-title mb-1">{title}</div>
      <div className={`${valueClassName} mb-1`}>{value}</div>
      {/* 카드마다 필요한 보조 문구(기준일, 검증 기간 등)를 가변적으로 렌더링한다. */}
      {subtexts.map((text, index) => (
        <div key={`${title}-subtext-${index}`} className="portfolio-intro-card-subtext mb-2">
          {text}
        </div>
      ))}
      <div style={{ height: chartHeight }}>
        {chartData ? (
          <Line data={chartData} options={chartOptions} />
        ) : (
          <div className="text-secondary fs-sm d-flex h-100 align-items-center justify-content-center text-center">
            {emptyMessage}
          </div>
        )}
      </div>
    </div>
  );
}
